<template>
    <div v-if="total" :style="{float: 'right'}">
        <a type="text" @click="getTimeline()" :style="{fontSize: '16px', color: '#515a6e'}">
            <Icon type="ios-pulse"></Icon>
        </a>
        <drawer :title="`Ticket ${id}: Timeline`" placement="right" width="850" :closable="true" v-model="show">
            <Timeline>
                <TimelineItem v-for="(tl, index) in ticket_timeline" :key="index" :color="getColorTL(index)">
                    <h2>{{lista_andamento[tl.andamento]}}</h2>
                    <p>
                        <Tag color="default">{{tl.data_hora_registro}}</Tag>
                        {{ tl.pessoa ? tl.pessoa.nome.replace(/ .*/, "") : "" }}
                        <span v-if="tl.erros==1">{{tl.erros}} erro encontrado</span>
                        <span v-if="tl.erros>1">{{tl.erros}} erros encontrados</span>
                    </p>
                    <Card dis-hover v-if="tl.descricao"><p><span v-html="tl.descricao"></span></p></Card>
                    <div class="multiselect__tags" v-if="tl.causa_bug && tl.causa_bug.length">
                        <div class="multiselect__tags-wrap">
                            <span class="multiselect__tag" v-for="(causa, key) in tl.causa_bug" :key="key"><span>{{ causa.descricao }}</span></span>
                        </div>
                    </div>
                    
                </TimelineItem>
            </Timeline>
        </drawer>
    </div>
</template>

<script>
    import "vue-multiselect/dist/vue-multiselect.min.css";

    const {moment} = require("../../../helpers/utils.js");
    export default {
        name: "pgd-timeline",
        props: {
            id: Number,
            total: Number
        },
        data() {
            return {
                show: false,
                ticket_timeline: [],
                lista_andamento: [
                    "Não atribuído", "Atribuído", "Em desenvolvimento", "Análise de Qualidade", "Em Teste",
                    "Validação Pull Request", "Validação Deploy", "Em Produção"
                ]
            }
        },
        created() {
        },
        methods: {
            async getTimeline() {
                this.show = true;
                try {
                    const URI = `ticket/${this.id}/timeline`;
                    const {data} = await this.$axios.get(URI);
                    this.ticket_timeline = data.map(timeline => {
                        timeline.data_hora_registro = moment(timeline.data_hora_registro).format("DD/MM/YYYY HH:mm");
                        return timeline;
                    });
                } catch (error) {
                    console.warn(error);
                }
            },
            getColorTL(index) {
                const tl_atual = this.ticket_timeline[index];
                const tl_anter =
                    index + 1 < this.ticket_timeline.length
                        ? this.ticket_timeline[index + 1]
                        : this.ticket_timeline[index];
                /**
                 * Caso tenha voltado de Testes para desenvolvimento adiciona a cor vermelho na TL
                 */
                if (
                    tl_atual.andamento == 2 &&
                    tl_atual.andamento < tl_anter.andamento
                ) {
                    return "red";
                }
                return "blue";
            }
        }
    };
</script>

<style scoped>
    h2 {
        font-size: 16px;
        margin: 0;
    }
</style>
